// src/supabase.js
import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL      = import.meta.env.VITE_SUPABASE_URL
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('❌ Variables VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY manquantes dans .env.local')
}

// Détecter un flux invitation/récupération depuis l'URL (hash ou query string)
const _urlParams = (() => {
  const h = window.location.hash
  const s = window.location.search
  const src = h.includes('access_token') ? h.substring(1)
            : s.includes('access_token') ? s.substring(1)
            : null
  if (!src) return null
  const p = new URLSearchParams(src)
  const type = p.get('type')
  if (type !== 'invite' && type !== 'recovery') return null
  sessionStorage.setItem('_auth_flow', type)
  return { type }
})()

// Instance unique — jamais recréée
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession:     true,
    autoRefreshToken:   true,
    // Activé uniquement si un token d'invitation est dans l'URL — désactivé sinon
    // pour éviter les conflits au démarrage (double getSession, refreshingDeferred)
    detectSessionInUrl: !!_urlParams,
    storageKey:         'solstice-auth',
    storage:            window.localStorage,
    // Web Lock désactivé — nécessaire : quand il est activé, tous les appels REST attendent
    // le lock JWT (exclusif), bloquant le chargement initial des données si un refresh est en cours.
    // Le bug de démarrage est corrigé dans AuthContext.jsx via Promise.race 5s.
    lock: (name, acquireTimeout, fn) => fn(),
  },
  realtime: {
    params: {
      eventsPerSecond: 1,
    },
    // Backoff plus conservateur : démarre à 3s (au lieu de 500ms) — réduit
    // la compétition réseau entre WebSocket et les appels REST (save, etc.)
    reconnectAfterMs: (tries) => Math.min(3000 * Math.pow(2, tries), 60000),
  },
})

export default supabase
